import { Children, cloneElement } from 'react';
import {
  FormControl, FormLabel, FormGroup, FormHelperText,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { CheckboxProps } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  inputLabel: {
    marginBottom: theme.spacing(1),
  },
  helperText: {
    marginTop: theme.spacing(1),
  },
}));

interface CheckboxGroupProps {
  readonly children: React.ReactNode;
  readonly id?: string;
  readonly label?: string;
  readonly name: string;
  readonly row?: boolean;
  readonly helperText?: React.ReactNode;
  readonly inGroup?: boolean;
  readonly InputProps?: CheckboxProps;
  readonly onClick?: () => void;
  readonly disabled?: boolean;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  children, id, label, name,
  helperText, row = true, inGroup = true, disabled = false,
  InputProps = {}, onClick = () => {},
}) => {
  const { classes } = useStyles();

  const childrenWithProps = Children.map(
    children,
    (child: JSX.Element) => {
      if (child) {
        return cloneElement(child, {
          name,
          inGroup,
          onClick,
          disabled,
          ...InputProps,
        });
      }

      return null;
    },
  );

  return (
    <FormControl
      className={classes.root}
      id={id || name}
      margin="normal"
    >
      {Boolean(label) && (
        <FormLabel
          htmlFor={inGroup === false ? name : undefined}
          className={classes.inputLabel}
          disabled={disabled}
        >
          {label}
        </FormLabel>
      )}

      <FormGroup
        row={row}
      >
        {childrenWithProps}
      </FormGroup>

      {Boolean(helperText) && (
        <FormHelperText className={classes.helperText}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
